// utils
import { paramCase } from 'src/utils/change-case';
import { _id, _postTitles } from 'src/_mock/assets';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const MOCK_TITLE = _postTitles[2];

const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
  WORKER_DASHBOARD: '/worker-dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  docs: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
  zoneUI: 'https://mui.com/store/items/zone-landing-page/',
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  freeUI: 'https://mui.com/store/items/minimal-dashboard-free/',
  figma:
    'https://www.figma.com/file/hjxMnGUJCjY7pX8lQbS7kn/%5BPreview%5D-Minimal-Web.v5.4.0?type=design&node-id=0-1&mode=design&t=2fxnS70DuiTLGzND-0',
  product: {
    root: `/product`,
    checkout: `/product/checkout`,
    details: (id) => `/product/${id}`,
    demo: {
      details: `/product/${MOCK_ID}`,
    },
  },
  post: {
    root: `/post`,
    details: (title) => `/post/${paramCase(title)}`,
    demo: {
      details: `/post/${paramCase(MOCK_TITLE)}`,
    },
  },
  // AUTH
  auth: {
    amplify: {
      login: `${ROOTS.AUTH}/amplify/login`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      register: `${ROOTS.AUTH}/amplify/register`,
      newPassword: `${ROOTS.AUTH}/amplify/new-password`,
      forgotPassword: `${ROOTS.AUTH}/amplify/forgot-password`,
    },
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
    firebase: {
      login: `${ROOTS.AUTH}/firebase/login`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      register: `${ROOTS.AUTH}/firebase/register`,
      forgotPassword: `${ROOTS.AUTH}/firebase/forgot-password`,
    },
    auth0: {
      login: `${ROOTS.AUTH}/auth0/login`,
    },
  },
  authDemo: {
    classic: {
      login: `${ROOTS.AUTH_DEMO}/classic/login`,
      register: `${ROOTS.AUTH_DEMO}/classic/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/classic/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/classic/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/classic/verify`,
    },
    modern: {
      login: `${ROOTS.AUTH_DEMO}/modern/login`,
      register: `${ROOTS.AUTH_DEMO}/modern/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/modern/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/modern/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/modern/verify`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    mail: `${ROOTS.DASHBOARD}/mail`,
    chat: `${ROOTS.DASHBOARD}/chat`,
    blank: `${ROOTS.DASHBOARD}/blank`,
    client: `${ROOTS.DASHBOARD}/client`,
    vendor: `${ROOTS.DASHBOARD}/vendor`,
    page_configuration: `${ROOTS.DASHBOARD}/page-configuration`,
    // organisation: `${ROOTS.DASHBOARD}/organisation`,
    measurement: `${ROOTS.DASHBOARD}/measurement`,
    worker: `${ROOTS.DASHBOARD}/worker`,
    kanban: `${ROOTS.DASHBOARD}/kanban`,
    calendar: `${ROOTS.DASHBOARD}/calendar`,
    fileManager: `${ROOTS.DASHBOARD}/file-manager`,
    permission: `${ROOTS.DASHBOARD}/permission`,
    general: {
      app: `${ROOTS.DASHBOARD}/app`,
      ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
      analytics: `${ROOTS.DASHBOARD}/analytics`,
      banking: `${ROOTS.DASHBOARD}/banking`,
      booking: `${ROOTS.DASHBOARD}/booking`,
      file: `${ROOTS.DASHBOARD}/file`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      list: `${ROOTS.DASHBOARD}/user/list`,
      cards: `${ROOTS.DASHBOARD}/user/cards`,
      profile: `${ROOTS.DASHBOARD}/user/profile`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      edit: (id) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/edit`,
      },
    },
    warehouse: {
      root: `${ROOTS.DASHBOARD}/organisation/list`,
      new: `${ROOTS.DASHBOARD}/organisation/new`,
      list: `${ROOTS.DASHBOARD}/organisation/list`,
      edit: (id) => `${ROOTS.DASHBOARD}/organisation/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/edit`,
      },
    },
    product: {
      root: `${ROOTS.DASHBOARD}/product`,
      new: `${ROOTS.DASHBOARD}/product/new`,
      details: (id) => `${ROOTS.DASHBOARD}/product/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/product/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/product/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/product/${MOCK_ID}/edit`,
      },
      productlog: {
        root: `${ROOTS.DASHBOARD}/productlog`,
      },
    },

    productcatogory: {
      root: `${ROOTS.DASHBOARD}/productcategory`,
      new: `${ROOTS.DASHBOARD}/productcategory/new`,
      details: (id) => `${ROOTS.DASHBOARD}/productcategory/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/productcategory/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/productcategory/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/productcategory/${MOCK_ID}/edit`,
      },
    },
    qrcode: {
      root: `${ROOTS.DASHBOARD}/qrcode`,
      new: `${ROOTS.DASHBOARD}/qrcode/new`,

    },
    inventory: {
      root: `${ROOTS.DASHBOARD}/inventory`,
      new: `${ROOTS.DASHBOARD}/inventory/new`,
      details: (id) => `${ROOTS.DASHBOARD}/inventory/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/inventory/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/inventory/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/inventory/${MOCK_ID}/edit`,
      },
    },
    inventorylog: {
      root: `${ROOTS.DASHBOARD}/inventorylog`,
    },
    fetchlist: {
      root: `${ROOTS.DASHBOARD}/fetchlist`,
      new: `${ROOTS.DASHBOARD}/fetchlist/new`,
      details: (id) => `${ROOTS.DASHBOARD}/fetchlist/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/fetchlist/${id}/edit`,
      scan: (id) => `${ROOTS.DASHBOARD}/fetchlist/${id}/scan`,
      demo: {
        details: `${ROOTS.DASHBOARD}/fetchlist/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/fetchlist/${MOCK_ID}/edit`,
      },
    },
    invoice: {
      root: `${ROOTS.DASHBOARD}/invoice`,
      new: `${ROOTS.DASHBOARD}/invoice/new`,
      details: (id) => `${ROOTS.DASHBOARD}/invoice/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/invoice/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}/edit`,
      },
    },
    process: {
      root: `${ROOTS.DASHBOARD}/process`,
      new: `${ROOTS.DASHBOARD}/process/new`,
      list: `${ROOTS.DASHBOARD}/process/list`,
      edit: (id) => `${ROOTS.DASHBOARD}/process/${id}/edit`,
    },
    workorder: {
      root: `${ROOTS.DASHBOARD}/workorder`,
      new: `${ROOTS.DASHBOARD}/workorder/new`,
      list: `${ROOTS.DASHBOARD}/workorder/list`,
      edit: (id) => `${ROOTS.DASHBOARD}/workorder/${id}/edit`,
      scan: (id) => `${ROOTS.DASHBOARD}/workorder/${id}/scan`,
    },
     notification: {
        root: `${ROOTS.DASHBOARD}/notification`,
      },
    post: {
      root: `${ROOTS.DASHBOARD}/post`,
      new: `${ROOTS.DASHBOARD}/post/new`,
      details: (title) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}`,
      edit: (title) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}`,
        edit: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}/edit`,
      },
    },
    order: {
      root: `${ROOTS.DASHBOARD}/order`,
      new: `${ROOTS.DASHBOARD}/order/new`,
      details: (id) => `${ROOTS.DASHBOARD}/order/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/order/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/order/${MOCK_ID}`,
      },
      logs: `${ROOTS.DASHBOARD}/order/logs`,
    },
    job: {
      root: `${ROOTS.DASHBOARD}/job`,
      new: `${ROOTS.DASHBOARD}/job/new`,
      details: (id) => `${ROOTS.DASHBOARD}/job/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/job/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/job/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/job/${MOCK_ID}/edit`,
      },
    },
    tour: {
      root: `${ROOTS.DASHBOARD}/tour`,
      new: `${ROOTS.DASHBOARD}/tour/new`,
      details: (id) => `${ROOTS.DASHBOARD}/tour/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/tour/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}/edit`,
      },
    },
    workerfetchlist: {
      root: `${ROOTS.DASHBOARD}/workerfetchlist`,
      new: `${ROOTS.DASHBOARD}/workerfetchlist/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/workerfetchlist/${id}/edit`,
      scan: (id) => `${ROOTS.DASHBOARD}/workerfetchlist/${id}/scan`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/workerfetchlist/${MOCK_ID}/edit`,
      },
    },
  },

  // WORKERDASHBOARD
  workerdashboard: {
    root: ROOTS.WORKER_DASHBOARD,
    workerfetchlist: {
      root: `${ROOTS.WORKER_DASHBOARD}/workerfetchlist`,
      new: `${ROOTS.WORKER_DASHBOARD}/workerfetchlist/new`,
      edit: (id) => `${ROOTS.WORKER_DASHBOARD}/workerfetchlist/${id}/edit`,
      scan: (id) => `${ROOTS.WORKER_DASHBOARD}/workerfetchlist/${id}/scan`,
      demo: {
        edit: `${ROOTS.WORKER_DASHBOARD}/workerfetchlist/${MOCK_ID}/edit`,
      },
    },
  },
};
